
import React from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Input } from '@/components/ui/input';

interface EnglishTranslationFieldProps {
  id: string;
  label: string;
  register: any;
  isTextArea?: boolean;
}

export const EnglishTranslationField = ({ 
  id, 
  label, 
  register, 
  isTextArea = false 
}: EnglishTranslationFieldProps) => {
  const InputComponent = isTextArea ? Textarea : Input;

  return (
    <div>
      <Label htmlFor={id}>{label}</Label>
      <InputComponent
        id={id}
        {...register(id)}
        className="mt-1"
        placeholder="English translation will appear here"
      />
    </div>
  );
};
